import Flatpickr from 'flatpickr';
import 'flatpickr/dist/themes/airbnb.css';
import moment from 'moment';
import React from 'react';
import ReactFlatpickr from 'react-flatpickr';
import { Input } from 'reactstrap';
import './TimePicker.scss';

declare module 'react-flatpickr' {
  interface DateTimePickerProps {
    className: string;
  }
}

type Props = {
  value: string;
  onChange: (selectedTime: string) => void;
  disabled?: boolean;
  hideIcon?: boolean;
  calendarRef?: (ref: HTMLDivElement) => void;
};

export const TimePicker = ({
  children,
  value,
  onChange,
  disabled,
  calendarRef,
  hideIcon,
}: React.PropsWithChildren<Props>) => {
  const flatpickrOptions: Flatpickr.Options.Options = {
    enableTime: true,
    noCalendar: true,
    dateFormat: 'h:i K',
    minuteIncrement: 1,
    wrap: true,
    onReady: (_selectedDates, _dateStr, instance) => {
      if (calendarRef) {
        calendarRef(instance.calendarContainer);
      }
    },
  };
  const dateValue = moment(value, 'HH:mm');

  const innerComponents = (
    <>
      <Input
        className="time-picker__input"
        type="text"
        data-input
        value={moment(value, 'HH:mm').format('h:mm A')}
        disabled={disabled}
      />
      {!hideIcon && (
        <div data-toggle className="time-picker__icon">
          <i className="far fa-clock" />
        </div>
      )}
      {children}
    </>
  );

  return (
    <div className="time-picker">
      {disabled ? (
        <div className="time-picker__flatpickr time-picker__flatpickr--disabled">
          {innerComponents}
        </div>
      ) : (
        <ReactFlatpickr
          className="time-picker__flatpickr"
          options={flatpickrOptions}
          value={dateValue.toDate()}
          onChange={dates => {
            onChange(moment(dates[0]).format('HH:mm'));
          }}
        >
          {innerComponents}
        </ReactFlatpickr>
      )}
    </div>
  );
};
